module.exports = __webpack_public_path__ + "static/media/noView2.865b43ff.png";